var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaLogo3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "WM_71",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 402.5 45.4",
    style: {
      enableBackground: "new 0 0 402.5 45.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6051E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,45.4 4.7,45.4 4.7,24.9 24,24.9 24,20.4 4.7,20.4 4.7,5.8 28.2,5.8 28.2,1.3 0,1.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "43.7,1.3 38.9,1.3 38.9,45.4 63.6,45.4 63.6,40.8 43.7,40.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "82.2,22.1 69.2,1.5 69.1,1.3 63.6,1.3 79.8,26.7 79.8,45.4 84.5,45.4 84.5,26.7 100.7,1.3 95.3,1.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "109.3,45.4 138.1,45.4 138.1,40.8 114.1,40.8 114.1,24.9 134.5,24.9 134.5,20.4 114.1,20.4  114.1,5.8 138.1,5.8 138.1,1.3 109.3,1.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176.9,13.6c0-7.7-5.4-12.3-14.6-12.3h-11.9v44.1h4.7V25.9h4.9l16.1,19.5h5.9l-16.5-19.7 C172.7,24.7,176.9,20.2,176.9,13.6z M155.2,5.7h7.1c6.5,0,9.8,2.6,9.8,7.8s-3.3,7.8-9.8,7.8h-7.1V5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M186.9,45.4h5l6.3-13.2h20.6l6.3,13.2h5L208.5,0.2L186.9,45.4z M200.3,27.6l8.1-17.1l8.1,17.1H200.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "242.2,1.3 237.5,1.3 237.5,45.4 262.2,45.4 262.2,40.8 242.2,40.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M268.6,45.4h5l6.3-13.2h20.6l6.3,13.2h5L290.1,0.2L268.6,45.4z M290.1,10.6l8.1,17.1H282L290.1,10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M346.6,13.6c0-7.7-5.4-12.3-14.6-12.3h-11.9v44.1h4.7V25.9h4.9l15.9,19.3l0.1,0.2h5.9l-16.5-19.7 C342.4,24.7,346.6,20.2,346.6,13.6z M324.8,5.7h7.1c6.5,0,9.8,2.6,9.8,7.8s-3.3,7.8-9.8,7.8h-7.1V5.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "381.2,24.3 359.9,0 359.9,45.4 364.6,45.4 364.6,12.1 381.2,31.1 397.8,12.1 397.8,45.4 402.5,45.4  402.5,0  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaLogo3);
export default __webpack_public_path__ + "static/media/FA_Logo-3.8ecc8b37ac71c500464002fa854ae867.svg";
export { ForwardRef as ReactComponent };